// src/pages/Landing/Hero.jsx
import React from "react";

export default function ConciergeHeader({ onClickStart }) {
  return (
    <section className="relative isolate overflow-hidden">
      {/* 배경 */}
      <div className="absolute inset-0 bg-[#F5F6F9]" />

      {/* 우상단 잘린 원 */}
      <div
        aria-hidden
        className="
          pointer-events-none absolute -top-[20vw] right-[-28vw]
          w-[90vw] max-w-[1200px] aspect-square rounded-full
          bg-gradient-to-b from-white to-[white]
        "
        style={{ filter: "blur(0.2px)" }}
      />

      {/* 콘텐츠 */}
      <div className="relative mx-auto max-w-[1200px] px-6 py-[96px] md:py-[140px] text-center">
        <h1 className="text-[28px] md:text-[56px] font-extrabold leading-tight text-[#111318]">
          앱 설치 없이, 가입·연동·게시까지
        </h1>
        <p
          className="mt-2 text-[26px] md:text-[48px] font-extrabold leading-tight"
          style={{ color: "var(--primary-600, #6F63F6)" }}
        >
          대신 마케팅 해드립니다
        </p>

        <p
          className="mt-6 text-[16px] md:text-[20px] text-[#6B7280]"
          style={{ color: "var(--coolgrey-600, #47526B)" }}
        >
          오늘부터 설치 없이 시작하세요
        </p>

        <div className="mt-10">
          <button
            type="button"
            onClick={onClickStart}
            className="
              inline-flex items-center justify-center
              h-[56px] px-8 rounded-2xl font-semibold
              text-white bg-[#6F63F6] hover:opacity-95 active:opacity-90
              shadow-[0_8px_24px_rgba(111,99,246,0.35)]
            "
          >
            지금 가입하기
          </button>
        </div>
      </div>
    </section>
  );
}
